import * as React from "react";
import ReactDOM from "react-dom";
import EnergyLabel from "./EnergyLabel";

export class EnergyLabelPortal {
  public static run(elements: NodeListOf<HTMLElement> | HTMLElement[]): void {
    elements.forEach((element: HTMLElement) => {
      const energyClass = element.dataset.energyClass;
      const energyMediaUrl = element.dataset.energyMedia;

      const priceSpan = element.querySelector<HTMLSpanElement>(".price-value");
      const hasDataFromProductDetails = element.className.includes("product-details");
      const energyLabelDiv = document.createElement("div");

      if (priceSpan && energyClass) {
        if (!hasDataFromProductDetails) {
          priceSpan.style.verticalAlign = "middle";
        }
        priceSpan.parentNode?.insertBefore(energyLabelDiv, priceSpan);
        ReactDOM.render(
          <EnergyLabel
            energyClass={energyClass}
            media={energyMediaUrl}
            size={hasDataFromProductDetails ? "big" : "small"}
          />,
          energyLabelDiv,
        );
        const childNode = energyLabelDiv.childNodes[0] as HTMLSpanElement;
        childNode.style.display = "inline-block";
        childNode.style.verticalAlign = "middle";
        // no clean code regarding react, but anyway static and not interactive
        energyLabelDiv.replaceWith(childNode);
      }
    });
  }
}

export default EnergyLabelPortal;
